import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getNetStatus } from '../../actions/network';
import NoNet from '../../components/NoNet/NoNet';
import styles from './Shop.module.less';

const selectNetStatus = createSelector(
  state => state.network,
  network => network.online,
);
export default function Shop() {
  const dispatch = useDispatch();
  const online = useSelector(selectNetStatus);

  useEffect(() => {
    dispatch(getNetStatus());
  }, []);

  return (
    <>
      {online === true && (
        <div className={styles.shop}>
          <span>商城</span>
        </div>
      )}
      {online === false && <NoNet />}
    </>
  );
}
